import { h } from "preact";
import { RoutableProps } from "preact-router";
import { addProductToDatabase } from "../../../api/product-api";
import { manufacturingConfigurations } from "../../../App";
import { AccessoriesPrinting } from "../../../components/AccesoriesPrinting";
import "./styles.scss";

export function MeissaOTSerialNumber(props: RoutableProps) {
    return <div class="orion-sit-serial-number-page">
        <AccessoriesPrinting manufacturingConfigurations={manufacturingConfigurations["MeissaOT"] ?? []} serialType="serial-8-base32" generateSerialNumber={(type) => addProductToDatabase(type)}/>
    </div>;
}
